export enum HighlightsTestIds {
  HIGHLIGHTS = 'highlights-highlights',
  HIGHLIGHT_BUTTON_PREFIX = 'highlights-highlight-',
  MENU_SECTION = 'highlights-menu-section',
  MENU_ITEM_PREFIX = 'highlights-menu-item-',
  DETAILS = 'highlights-details',
  DETAILS_PUBLISHED_AT = 'highlights-details-published-at',
  DETAILS_IMAGE = 'highlights-details-image',
  DETAILS_VIDEO = 'highlights-details-video',
  DETAILS_TEXT = 'highlights-details-text',
  MODAL = 'highlights-modal',
  UNREAD_INDICATOR = 'highlights-unread-indicator',
}

export enum HighlightsAdminTestIds {
  LIST = 'highlights-list',
  LIST_NEW = 'highlights-list-new',
  LIST_MENU_DELETE = 'highlights-menu-delete',
  LIST_ACTIVE_SWITCH_PREFIX = 'highlights-active-',
  LIST_LIVE_PREFIX = 'highlights-live-',
  FORM_TITLE = 'highlights-form-title',
  FORM_TEXT = 'highlights-form-text',
  FORM_MEDIA_INPUT = 'highlights-form-media-input',
  FORM_MEDIA = 'highlights-form-media',
  FORM_MEDIA_REMOVE = 'highlights-form-media-remove',
  FORM_PUBLISHED_AT = 'highlights-form-published-at',
  FORM_ACTIVE = 'highlights-form-active',
  FORM_SUBMIT = 'highlights-form-submit',
  FORM_CANCEL = 'highlights-form-cancel',
  FORM_PREVIEW_BUTTON = 'highlights-form-preview-button',
  FORM_PREVIEW_DETAILS = 'highlights-form-preview-details',
  FORM_PREVIEW_MODAL = 'highlights-form-preview-modal',
}
